import React, { Component } from 'react'
import DragAndDrop from '@ui/DragAndDrop'
import Row from './Row'

export default class Counter extends Component {
  handleChange = (row, value) => {
    const { selected, onChange } = this.props
    let newSelected = { ...selected }
    if (newSelected) {
      newSelected[row] = value
    } else {
      newSelected = { [row]: value }
    }

    if (onChange) onChange(newSelected)
  }

  renderItem = row => {
    const {
      id,
      editable,
      selected,
      minCount,
      maxCount,
      onRemove,
      inactive,
      onEdit
    } = this.props

    return (
      <Row
        key={`${id}-${row.value}`}
        name={row.value}
        text={row.text}
        value={selected ? selected[row.value] || minCount : minCount}
        onChange={this.handleChange}
        onEdit={onEdit}
        min={minCount}
        max={maxCount}
        editable={editable}
        onRemove={onRemove}
        inactive={inactive}
      />
    )
  }

  renderRow = (row, rowIndex) => {
    const { id, editable, onDrag, onDrop } = this.props

    return editable ? (
      <DragAndDrop
        key={`${id}-${row.value}`}
        index={rowIndex}
        itemType='row'
        onMove={onDrag}
        onDrop={onDrop}
      >
        {this.renderItem(row)}
      </DragAndDrop>
    ) : (
      this.renderItem(row)
    )
  }

  render() {
    const { rows } = this.props
    return <div>{rows.map(this.renderRow)}</div>
  }
}
